import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { Empregador } from '../../api.service';
import {
  itensNavegacaoModuloGerencial,
  moduloGerencialPorUrl,
  ModuloGerencial
} from '../../core/rotas/navegacao-menu-gerencial';
import { ServicoEmpregadorAdministrativo } from '../empregador/servico-empregador-administrativo';
import { ServicoSessaoGerencial } from '../menu/servico-sessao-gerencial';
import { TelaSolicitacoesComponent } from '../solicitacoes/tela-solicitacoes.component';
import { LayoutModuloGerencialComponent } from '../../layout/layout-modulo-gerencial.component';
import { TelaCadastroSecretariasComponent } from './tela-cadastro-secretarias.component';
import { TelaListagemFeriasComponent } from './tela-listagem-ferias.component';

@Component({
  selector: 'app-tela-gerenciador-ferias',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModuloGerencialComponent,
    TelaCadastroSecretariasComponent,
    TelaListagemFeriasComponent,
    TelaSolicitacoesComponent
  ],
  templateUrl: './tela-gerenciador-ferias.component.html'
})
export class TelaGerenciadorFeriasComponent implements OnInit, OnDestroy {
  agora = new Date();
  aba: ModuloGerencial = 'ferias';
  mensagem = '';
  empregadores: Empregador[] = [];
  empregadorSelecionado = '';
  private atualizacaoRelogio?: number;
  private assinaturaRoteador?: Subscription;

  constructor(
    readonly sessao: ServicoSessaoGerencial,
    private readonly servicoEmpregador: ServicoEmpregadorAdministrativo,
    private readonly roteador: Router
  ) {}

  get itensMenu() {
    return itensNavegacaoModuloGerencial(
      this.aba === 'secretarias' ? 'secretarias' : this.aba === 'ferias-lista' ? 'ferias-lista' : 'ferias'
    );
  }

  ngOnInit() {
    this.sincronizarAba(this.roteador.url);
    this.sessao.carregar();
    this.atualizacaoRelogio = window.setInterval(() => this.agora = new Date(), 1000);
    this.assinaturaRoteador = this.roteador.events
      .pipe(filter((evento): evento is NavigationEnd => evento instanceof NavigationEnd))
      .subscribe(evento => this.sincronizarAba(evento.urlAfterRedirects));
    this.servicoEmpregador.listarDaSessao(this.sessao.usuario).subscribe({
      next: empregadores => {
        this.empregadores = empregadores;
        this.empregadorSelecionado = this.empregadorSelecionado || empregadores[0]?.id || '';
      },
      error: () => this.mensagem = 'Nao foi possivel carregar empregadores.'
    });
  }

  ngOnDestroy() {
    if (this.atualizacaoRelogio) {
      window.clearInterval(this.atualizacaoRelogio);
    }
    this.assinaturaRoteador?.unsubscribe();
  }

  private sincronizarAba(url: string) {
    const modulo = moduloGerencialPorUrl(url);
    this.aba = modulo === 'secretarias' || modulo === 'ferias-lista' ? modulo : 'ferias';
  }
}
